import axiosAuth from '../../axiosMain';

async function index() {
  let response = await axiosAuth.get('/co2_footprint/by_categories');
  return response.data;
}

export default {
  index,
};
